export default __webpack_public_path__ + "static/media/opensea.203348e1.svg";